import { render } from "./TaskRecord.vue?vue&type=template&id=694a14e3"
import script from "./TaskRecord.vue?vue&type=script&lang=js"
export * from "./TaskRecord.vue?vue&type=script&lang=js"

import "./TaskRecord.vue?vue&type=style&index=0&id=694a14e3&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__